/* snz 13 Oct 2026 — colour-scoped product gallery.
   Rendered only where snippets/product-media-gallery.liquid finds the
   custom.gallery_colours metafield. Every photo is in the page; this only
   toggles .snz-goff so the slider, the thumbnail strip and the zoom modal show
   the chosen colour's photos (+ shared), or the curated hero set before a
   colour is chosen. Colours without a list fall back to the hero set. */
(function () {
  function idOf(v) {
    v = String(v || '');
    return v.slice(v.lastIndexOf('-') + 1);
  }

  function wire(g) {
    if (g.dataset.snzgWired) return;
    var cfgEl = g.querySelector('script[data-snzg]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    g.dataset.snzgWired = '1';
    var map = cfg.map || {};
    var lists = map.c || {};
    var sectionId = g.id.replace(/^MediaGallery-/, '');

    // Returns the ids to show, in display order: lead photo, the list, shared.
    function setFor(colour, leadId) {
      // 19 Oct 2026: the "Other" colour was renamed (now "Other (Custom Colour)")
      // but custom.gallery_colours still keys it by the old label. Any "Other (...)"
      // value with no list of its own uses whichever "Other (...)" list exists.
      if (colour != null && !lists[colour] && /^Other \(/.test(colour)) {
        for (var k in lists) { if (/^Other \(/.test(k)) { colour = k; break; } }
      }
      var list = colour != null && lists[colour] && lists[colour].length ? lists[colour] : map.hero || [];
      var order = [];
      var s = {};
      (leadId ? [leadId] : []).concat(list, map.shared || []).forEach(function (id) {
        id = String(id);
        if (!s[id]) { s[id] = 1; order.push(id); }
      });
      s.order = order;
      return s;
    }

    // Move the visible items to the front of their list in display order.
    function sortList(ul, keyOf, order) {
      if (!ul) return;
      var byId = {};
      Array.prototype.forEach.call(ul.children, function (el) { var k = keyOf(el); if (k) byId[k] = el; });
      var anchor = ul.firstElementChild;
      order.forEach(function (id) {
        var el = byId[id];
        if (!el) return;
        if (el !== anchor) ul.insertBefore(el, anchor);
        else anchor = anchor.nextElementSibling;
      });
    }

    function refresh(sc) {
      if (!sc) return;
      // Only recount a slider that is really sliding (2+ visible slides). On
      // desktop the main viewer shows one photo at a time; recounting it there
      // leaves Dawn with no slide offset and its slideChanged handler throws.
      var shown = Array.prototype.filter.call(sc.querySelectorAll('[id^="Slide-"]'), function (el) { return el.clientWidth > 0; });
      if (shown.length < 2) {
        // A one-photo colour on a phone: Dawn won't recount, so set the
        // counter by hand rather than leave the previous colour's total.
        var tot = sc.querySelector('.slider-counter--total');
        var cur = sc.querySelector('.slider-counter--current');
        if (tot && shown.length) tot.textContent = '1';
        if (cur && shown.length) cur.textContent = '1';
        return;
      }
      // Back to the first slide: the visible set has just changed.
      try {
        if (sc.slider) sc.slider.scrollLeft = 0;
        if (sc.resetPages) sc.resetPages();
        if (sc.update) sc.update();
      } catch (e) {}
    }

    // 20 Oct 2026, audit #86: product-thumbnail.liquid parks slide photos in
    // data-snz-defer-* and its go() skips hidden (.snz-goff) slides, so a slide
    // this reveals may still hold a placeholder. Fill in every visible one, but
    // only once go() has run, so nothing is pulled into the LCP window.
    function promote() {
      if (!window.snzGalleryDeferDone) return;
      g.querySelectorAll('.product__media-list > li[data-media-id]:not(.snz-goff) img[data-snz-defer-srcset]').forEach(function (im) {
        im.srcset = im.getAttribute('data-snz-defer-srcset');
        im.src = im.getAttribute('data-snz-defer-src');
        im.removeAttribute('data-snz-defer-srcset');
        im.removeAttribute('data-snz-defer-src');
      });
    }

    function apply(s) {
      sortList(g.querySelector('.product__media-list'), function (el) { return el.dataset.mediaId && idOf(el.dataset.mediaId); }, s.order);
      sortList(g.querySelector('.thumbnail-list'), function (el) { return el.dataset.target && idOf(el.dataset.target); }, s.order);
      g.querySelectorAll('.product__media-list > li[data-media-id]').forEach(function (li) {
        li.classList.toggle('snz-goff', !s[idOf(li.dataset.mediaId)]);
      });
      g.querySelectorAll('.thumbnail-list__item[data-target]').forEach(function (t) {
        t.classList.toggle('snz-goff', !s[idOf(t.dataset.target)]);
      });
      var thumbs = g.querySelector('[id^="GalleryThumbnails"]');
      if (thumbs) {
        var n = thumbs.querySelectorAll('.thumbnail-list__item:not(.snz-goff)').length;
        thumbs.classList.toggle('thumbnail-slider--no-slide', n <= 3);
      }
      var modal = document.getElementById('ProductModal-' + sectionId);
      if (modal) {
        modal.querySelectorAll('.product-media-modal__content > [data-media-id]').forEach(function (m) {
          var on = !!s[String(m.dataset.mediaId)];
          m.classList.toggle('snz-goff', !on);
          if (on) m.classList.remove('product__media-item--variant');
        });
      }
      promote();
      refresh(g.querySelector('[id^="GalleryViewer"]'));
      refresh(thumbs);
    }

    apply(setFor(cfg.mode === 'colour' ? cfg.colour : null, cfg.lead));

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
        var d = e && e.data;
        if (!d || d.sectionId !== sectionId || !d.variant) return;
        var v = d.variant;
        // Dawn swaps the modal's contents after its own fetch; run after it.
        apply(setFor(v['option' + cfg.opt], v.featured_media && v.featured_media.id));
      });
    }

    // Dawn pre-selects the first colour, but the page opens on the hero set.
    // Picking that already-selected colour fires no change event, so handle it
    // here: a click on the checked swatch shows that colour's photos.
    var info = document.querySelector('product-info[data-section="' + sectionId + '"]') || document;

    // 20 Oct 2026, audit93 F5: the new colour's photo only started downloading
    // after Dawn's section fetch came back (1-3 s on a phone). Warm the first
    // photo of a colour as soon as the shopper points at / touches its swatch,
    // with the same srcset + sizes as the slide, so the swap hits the cache.
    var warmed = {};
    function warm(colour) {
      if (colour == null || warmed[colour]) return;
      warmed[colour] = 1;
      var id = setFor(colour, null).order[0];
      if (!id) return;
      var li = g.querySelector('.product__media-list > li[data-media-id$="-' + id + '"]');
      var im = li && li.querySelector('img');
      if (!im) return;
      var ss = im.getAttribute('data-snz-defer-srcset') || im.getAttribute('srcset');
      var src = im.getAttribute('data-snz-defer-src') || im.getAttribute('src');
      if (!ss && (!src || src.indexOf('data:') === 0)) return;
      var pre = new Image();
      pre.decoding = 'async';
      if (im.getAttribute('sizes')) pre.sizes = im.getAttribute('sizes');
      if (ss) pre.srcset = ss;
      if (src && src.indexOf('data:') !== 0) pre.src = src;
    }
    function warmFrom(e) {
      var lab = e.target && e.target.closest && e.target.closest('variant-selects label');
      var inp = lab && lab.htmlFor ? document.getElementById(lab.htmlFor) : null;
      if (!inp || inp.type !== 'radio') return;
      var fs = inp.closest('fieldset');
      var sets = Array.prototype.slice.call(inp.closest('variant-selects').querySelectorAll('fieldset'));
      if (sets.indexOf(fs) + 1 !== cfg.opt) return;
      warm(inp.value);
    }
    info.addEventListener('pointerover', warmFrom, { passive: true });
    info.addEventListener('touchstart', warmFrom, { passive: true });
    info.addEventListener('pointerdown', function (e) {
      var inp = e.target.closest && e.target.closest('label') ? document.getElementById(e.target.closest('label').htmlFor) : null;
      if (inp) inp._snzWas = inp.checked;
    }, true);
    info.addEventListener('click', function (e) {
      var inp = e.target;
      if (!inp || inp.type !== 'radio' || !inp.closest('variant-selects') || !inp._snzWas) return;
      inp._snzWas = false;
      var fs = inp.closest('fieldset');
      var sets = Array.prototype.slice.call(inp.closest('variant-selects').querySelectorAll('fieldset'));
      if (sets.indexOf(fs) + 1 !== cfg.opt) return;
      var active = g.querySelector('.product__media-list > li.is-active');
      apply(setFor(inp.value, active ? idOf(active.dataset.mediaId) : cfg.lead));
    });
  }

  function wireAll() {
    document.querySelectorAll('media-gallery').forEach(wire);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wireAll);
  else wireAll();
})();
